import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import activities from './modules/activities'
import quotes from './modules/quotes'
import picklists from './modules/picklists'
import schema from './modules/schema'
import products from './modules/products'
import users from './modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    curDate: new Date()
  },
  mutations: {
    'SET_CUR_DATE' (state, newDate) {
      state.curDate = newDate
    }
  },
  actions: {
    setCurDate ({ commit }, newDate) {
      commit('SET_CUR_DATE', newDate)
    }
  },
  getters: {

  },
  modules: {
    auth,
    activities,
    picklists,
    quotes,
    schema,
    products,
    users
  }
})
